export default __webpack_public_path__ + "static/media/Angular.922931ca.gif";